import styled, { css } from "styled-components";
import convertHexToRgba from "~/helpers/convertHexToRgba";

export default styled.div`
  ${({ theme }) => {
    const { colors, media } = theme;

    return css`
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh;
      z-index: 2000;
      display: flex;
      justify-content: center;
      align-items: center;

      .modal-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: ${convertHexToRgba("#000000", 0.4)};
      }

      .modal-card {
        position: relative;
        background: ${colors.primary.white};
        border-radius: 24px;
        box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.2);
        padding: 48px 64px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 24px;
        max-width: 670px;
        width: 90%;
        z-index: 10;
      }

      .close-button {
        position: absolute;
        top: 16px;
        right: 16px;
        cursor: pointer;
        height: 32px;
        width: 32px;
        padding: 8px;
      }

      .heading {
        color: #141928;
        font-size: 24px;
        font-weight: 700;
        line-height: 28px;
        text-align: center;
        margin-top: 16px;
      }

      .subheading {
        color: #141928;
        font-size: 16px;
        font-weight: 400;
        text-align: center;
        line-height: 24px;
      }

      .timer-circle {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        border: 2px solid #e21a2c;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .timer-number {
        font-size: 32px;
        font-weight: 700;
        color: #141928;
      }

      .button-group {
        display: flex;
        justify-content: center;
        gap: 16px;
        margin-top: 16px;
        flex-wrap: wrap;
      }

      .continue-btn {
        background-color: #e21a2c !important;
        border: 1px solid #e21a2c !important;
        color: #fff !important;
        font-weight: 700;
        padding: 12px 24px;
        border-radius: 32px;
        text-transform: uppercase;
      }

      .cancel-btn {
        background-color: #fff !important;
        border: 1px solid #141928 !important;
        color: #141928 !important;
        font-weight: 700;
        padding: 12px 24px;
        border-radius: 32px;
        text-transform: uppercase;
      }

      ${media.tablet.down} {
        .modal-card {
          padding: 32px 24px;
          width: 90%;
        }

        .heading {
          font-size: 20px;
        }

        .timer-circle {
          width: 64px;
          height: 64px;
        }

        .timer-number {
          font-size: 28px;
        }
      }
    `;
  }}
`;
